import { Dialog, DialogContent, DialogHeader, ToastLevel, useIntl, useToast } from "@metsooutotec/modes-react-components"
import { FC, useState } from "react"
import styles from "./dispatch-submit-modal.module.css"
import { SDASensor } from "../../models/sensor-dispatch-allocation"
import { DispatchEditListDto } from "../../models/stock-management-models"
import { convertDateToDDMMMYYYY } from "components/utils/date-formatter-utils"
import stockManagementStore from "../../stores/stock-management-store"
import ModalsButtons from "components/common/modals-buttons"

interface DispatchSubmitProps {
    isOpen: boolean | undefined
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    dispatchDate: Date
    listOfSensors: SDASensor[]
    customerId: string
    siteId?: string | undefined
    partNumber: string
}
const DispatchSubmitModal: FC<DispatchSubmitProps> = ({ isOpen, setIsOpen, dispatchDate, listOfSensors, customerId, siteId, partNumber }) => {
    const { formatMessage } = useIntl()
    const { setMessage } = useToast()
    const [loading, setLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<{
        isError: boolean
        errorMessage: string
    }>({ isError: false, errorMessage: "" })

    const labels = {
        header: `${formatMessage("dispatchSubmit.header")}`,
        description: formatMessage("dispatchSubmit.description"),
    }
    const onConfirm = async (e: React.FormEvent): Promise<void> => {
        try {
            setLoading(true)

            if (listOfSensors.length > 0 && dispatchDate) {
                const macAddresses: string[] = listOfSensors.map(s => s.macAddress)
                const dto: DispatchEditListDto = {
                    partNumber,
                    sensorsMacAddress: macAddresses,
                    dispatchDate: convertDateToDDMMMYYYY(dispatchDate),
                    customerId,
                    siteId: siteId || undefined,
                }
                const result = await stockManagementStore.updateDispatch(dto)
                if (result.passed) {
                    setMessage("It has been submitted!", ToastLevel.SUCCESS, 4000)
                    onClose()
                } else {
                    setIsError({ isError: true, errorMessage: result.message })
                }
            } else {
                setIsError({
                    isError: true,
                    errorMessage: "No sensors to be submitted!",
                })
                return
            }
        } catch {
            console.error("Something went wrong on DispatchSubmitModal")
        } finally {
            setLoading(false)
        }
    }
    function onClose() {
        setLoading(false)
        setIsOpen(false)
    }
    return (
        <Dialog open={isOpen} dimmer size='small'>
            <DialogHeader>{labels.header}</DialogHeader>
            {isError.isError && <p className={styles.errorMessage}>{isError.errorMessage}</p>}
            <DialogContent data-cy='dialog-content'>
                <>{labels.description}</>
            </DialogContent>
            <ModalsButtons handleSubmit={onConfirm} onCloseProcess={onClose} isLoading={loading} />
        </Dialog>
    )
}

export default DispatchSubmitModal
